"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Component for Metaform checklist field
 */
class MetaformChecklistFieldComponent extends react_1.default.Component {
    /**
     * Constructor
     *
     * @param props component props
     */
    constructor(props) {
        super(props);
        /**
         * Checklist render method
         */
        this.renderChecklist = () => {
            const options = this.props.field.options || [];
            const selectedOptions = this.getSelectedOptions();
            return (options.map(option => this.renderOption(option, selectedOptions)));
        };
        /**
         * Renders an option
         *
         * @param option option
         * @param selectedOptions array of selected options
         */
        this.renderOption = (option, selectedOptions) => {
            const checked = selectedOptions.includes(option.name);
            if (this.props.formReadOnly || this.props.field.readonly) {
                return (react_1.default.createElement("div", { key: option.name },
                    this.props.renderIcon(checked ? "check-square-o" : "square-o", option.name),
                    react_1.default.createElement("span", { style: { verticalAlign: "super" } }, option.text)));
            }
            else {
                return (react_1.default.createElement("div", { key: option.name },
                    react_1.default.createElement("input", { type: "checkbox", name: this.props.field.name, value: option.name, checked: checked, onChange: (event) => this.onCheckboxChange(option, event.target.checked) }),
                    react_1.default.createElement("span", null, option.text)));
            }
        };
        /**
         * Returns array of selected options
         */
        this.getSelectedOptions = () => {
            if (!this.props.value) {
                return [];
            }
            return this.props.value.split(",");
        };
        /**
         * Event handler for checkbox change
         *
         * @param option option
         * @param checked whether checkbox was checked
         */
        this.onCheckboxChange = (option, checked) => {
            const selectedOptions = this.getSelectedOptions();
            const value = (checked ? [...selectedOptions, option.name] : selectedOptions.filter(selectedOption => selectedOption !== option.name)).join(",");
            this.props.onValueChange(value);
        };
        this.state = {};
    }
    /**
     * Component render method
     */
    render() {
        if (!this.props.field.name) {
            return null;
        }
        return (react_1.default.createElement("div", { key: this.props.field.name }, this.renderChecklist()));
    }
}
exports.MetaformChecklistFieldComponent = MetaformChecklistFieldComponent;
//# sourceMappingURL=data:application/json;base64,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